import { render, staticRenderFns } from "./gasLeakDetectionAlarmDoc.vue?vue&type=template&id=55be6660"
import script from "./gasLeakDetectionAlarmDoc.vue?vue&type=script&lang=js"
export * from "./gasLeakDetectionAlarmDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55be6660')) {
      api.createRecord('55be6660', component.options)
    } else {
      api.reload('55be6660', component.options)
    }
    module.hot.accept("./gasLeakDetectionAlarmDoc.vue?vue&type=template&id=55be6660", function () {
      api.rerender('55be6660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/glda/gasLeakDetectionAlarmDoc.vue"
export default component.exports